import React, { SVGProps } from "react";

import { useIconIdPrefix } from "~/components/Icons/utils/useIconIdPrefix";

const VerizonLogo = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const prefix = useIconIdPrefix("VerizonLogo");

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" {...props} viewBox="0 0 36 32" fill="none">
      <path
        d="M21.9747 31.6013L9.84272 0H0L12.132 31.6013C12.2239 31.8423 12.4549 32 12.712 32H22.5548C22.2976 32 22.0666 31.8423 21.9747 31.6013Z"
        fill={`url(#${prefix}-paint0_radial_15000_3941)`}
      />
      <path
        d="M13.292 31.6013L25.4239 0H35.2667L23.1347 31.6013C23.0428 31.8423 22.8118 32 22.5546 32H12.7119C12.969 32 13.2001 31.8423 13.292 31.6013Z"
        fill="#F50A23"
      />
      <defs>
        <radialGradient
          id={`${prefix}-paint0_radial_15000_3941`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.76907 -15.9687 17.2709 6.24118 20.4907 26.4895)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5FF1E" />
          <stop offset="0.257" stopColor="#F5FF1E" />
          <stop offset="0.2655" stopColor="#F5FA1E" />
          <stop offset="0.423" stopColor="#F5A620" />
          <stop offset="0.5621" stopColor="#F56321" />
          <stop offset="0.6779" stopColor="#F53322" />
          <stop offset="0.7657" stopColor="#F51523" />
          <stop offset="0.8155" stopColor="#F50A23" />
        </radialGradient>
      </defs>
    </svg>
  );
};

VerizonLogo.displayName = "VerizonLogo";
export default VerizonLogo;
